import { useQuery } from "@tanstack/react-query"
import { merge } from "lodash"

import { useMovieShowTime } from "../useMovieShowTime"
import { IMovieShowTime } from "extensions/movie-show-time/interfaces"

interface IOptions {
  enabled?: boolean
}

type UseMovie = (
  id: string,
  cinemaCode: string,
  options: IOptions
) => { movie: IMovieShowTime; isLoading: boolean }

const DEFAULT_OPTION = {
  enabled: true,
}

export const useMovie: UseMovie = (id, cinemaCode, options) => {
  const { enabled }: IOptions = merge(DEFAULT_OPTION, options)

  const { showtime, isLoading } = useMovieShowTime(cinemaCode, {
    enabled: enabled,
  })

  const { data, isLoading: isMovieLoading } = useQuery<IMovieShowTime>({
    queryKey: ["movie", cinemaCode, id],
    queryFn: (): IMovieShowTime =>
      showtime.find((movie) => {
        return movie.id === id
      }),
    enabled: !!(showtime && showtime.length > 0),
    // TODO:Implement Stale Time
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  })

  return { movie: data, isLoading: isLoading || isMovieLoading }
}
